import {requestAnimationFrame} from 'CommonUtils/raf.js';
import {startTcApp} from '@cliotech-web/trading-conditions';
import './tc.css';

let lang = languageAttributes.content_lang ? languageAttributes.content_lang : languageAttributes.languageCode;
let broker = languageAttributes.broker;
let header = document.getElementById('main-header').offsetHeight;
let header_height = window.innerWidth < 768 ? 10 + header : 20 + header;
let content_obj;
if(languageAttributes.spokenLanguageCode === 'hi'){
  content_obj = require('./tc-tabs.js');
}else{
  content_obj = require('../../content/' + lang + '/tc.js') || require('../../content/en/tc.js');
}



switch (lang) {
  case 'cn':
    lang = 'ZH'; break;
  case 'tw':
    lang = 'TW'; break;
  case 'cz':
    lang = 'cs'; break;
    case 'hi':
      lang = languageAttributes.spokenLanguageCode === 'hi' ? 'hi' : 'en'; break;
      //lang = 'en'; break;
}
  
let tcApp = document.getElementById('tcApp'),
    ec, 
    ecLoaded = false;

    function doScrolling() {
        if (!ecLoaded) {
            ecLoaded = true;
            startTcApp(tcApp, broker, lang , content_obj.content ,header_height)
            requestAnimationFrame(()=> tcApp.classList.remove('loading'))
        }
    
    }

    window.scrollingTasks.push(doScrolling);


    if (window.location.hash) doScrolling();